import { ApprovalStepStatus } from '../types/ApprovalData';
import { ACTOR } from '../constants/actors';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import unescapedText from 'I18n/utils/unescapedText';
export const actorToApprovalUser = (actor, usersRecord, agentsRecord) => {
  const {
    actorType,
    id
  } = actor;
  if (typeof actorType === 'symbol') {
    return {
      actor: {
        actorType: ACTOR.USER,
        id
      },
      email: '',
      firstName: `Unknown actor`,
      lastName: `(${id})`
    };
  }
  switch (actorType) {
    case ACTOR.USER:
      {
        var _user$email, _user$firstName, _user$lastName;
        const userId = Number(id);
        const user = usersRecord[userId];
        return {
          // TODO: Remove activeUserId once settings-ui-quotes is updated to use actor.id
          activeUserId: userId,
          actor: {
            actorType: ACTOR.USER,
            id
          },
          // TODO: Replace email, firstName, lastName with displayName
          email: (_user$email = user === null || user === void 0 ? void 0 : user.email) !== null && _user$email !== void 0 ? _user$email : '',
          firstName: (_user$firstName = user === null || user === void 0 ? void 0 : user.firstName) !== null && _user$firstName !== void 0 ? _user$firstName : '',
          lastName: (_user$lastName = user === null || user === void 0 ? void 0 : user.lastName) !== null && _user$lastName !== void 0 ? _user$lastName : ''
        };
      }
    case ACTOR.AGENT:
      {
        var _agentsRecord$id;
        const agentDisplayName = (_agentsRecord$id = agentsRecord[id]) === null || _agentsRecord$id === void 0 ? void 0 : _agentsRecord$id.displayName;
        return {
          actor: {
            actorType: ACTOR.AGENT,
            id
          },
          email: '',
          firstName: agentDisplayName !== null && agentDisplayName !== void 0 ? agentDisplayName : unescapedText('productApprovals.agent.defaultName'),
          lastName: agentDisplayName ? '' : `(${id})`
        };
      }
    case ACTOR.TEAM:
      return {
        actor: {
          actorType: ACTOR.TEAM,
          id
        },
        email: '',
        firstName: `TODO: Team actor`,
        lastName: `(${id})`
      };
    default:
      return unreachableFallback(actorType, {
        actor: {
          actorType,
          id
        },
        email: '',
        firstName: `Unknown actor`,
        lastName: `(${id})`
      });
  }
};
export const hasPendingAgentApprovalStep = chirpApproval => {
  var _chirpApproval$approv;
  return ((_chirpApproval$approv = chirpApproval === null || chirpApproval === void 0 ? void 0 : chirpApproval.approvalSteps) !== null && _chirpApproval$approv !== void 0 ? _chirpApproval$approv : []).some(step => step.approver.actorType === ACTOR.AGENT && step.approvalStepStatus === ApprovalStepStatus.APPROVAL_PENDING);
};
export const chirpApprovalToApprovalData = (chirpApproval, usersRecord, agentsRecord, approvalType, approvalAction) => {
  var _chirpApproval$approv2, _chirpApproval$reques, _chirpApproval$cancel, _chirpApproval$dueDat, _ref;
  return {
    id: chirpApproval.id,
    portalId: chirpApproval.portalId,
    title: chirpApproval.title,
    createDateTimestamp: chirpApproval.createDateTimestamp,
    // TODO Remove type cast when we've fully migrated to CHIRP
    approvalStatus: chirpApproval.approvalStatus,
    approvalType,
    approvalAction,
    // TODO Remove type cast when we've fully migrated to CHIRP
    approvalRules: chirpApproval.approvalRules,
    requester: actorToApprovalUser(chirpApproval.requester, usersRecord, agentsRecord),
    approvalSteps: ((_chirpApproval$approv2 = chirpApproval.approvalSteps) !== null && _chirpApproval$approv2 !== void 0 ? _chirpApproval$approv2 : []).map(step => {
      var _step$approvedNote, _step$changesRequeste, _step$rejectionNote;
      return {
        id: step.id,
        order: step.order,
        approver: actorToApprovalUser(step.approver, usersRecord, agentsRecord),
        // TODO Remove type cast when we've fully migrated to CHIRP
        approvalStepStatus: step.approvalStepStatus,
        createDateTimestamp: step.createDateTimestamp,
        approvedNote: (_step$approvedNote = step.approvedNote) !== null && _step$approvedNote !== void 0 ? _step$approvedNote : '',
        changesRequestedNote: (_step$changesRequeste = step.changesRequestedNote) !== null && _step$changesRequeste !== void 0 ? _step$changesRequeste : null,
        rejectionNote: (_step$rejectionNote = step.rejectionNote) !== null && _step$rejectionNote !== void 0 ? _step$rejectionNote : null
      };
    }),
    requestNote: (_chirpApproval$reques = chirpApproval.requestNote) !== null && _chirpApproval$reques !== void 0 ? _chirpApproval$reques : '',
    cancelNote: (_chirpApproval$cancel = chirpApproval.cancelNote) !== null && _chirpApproval$cancel !== void 0 ? _chirpApproval$cancel : null,
    cancelNoteTimestamp: null,
    dueDate: (_chirpApproval$dueDat = chirpApproval.dueDate) !== null && _chirpApproval$dueDat !== void 0 ? _chirpApproval$dueDat : null,
    approvalConcluded: Boolean(chirpApproval.approvalConcluded),
    approvalConclusionReason: // TODO Remove type cast when we've fully migrated to CHIRP
    (_ref = chirpApproval.approvalConclusionReason) !== null && _ref !== void 0 ? _ref : null
  };
};